import { pgTable, uuid, integer, timestamp, primaryKey, index } from "drizzle-orm/pg-core";
import { products } from "./products.js";
import { inventoryLocations } from "./inventory-locations.js";

export const inventoryStock = pgTable(
  "inventory_stock",
  {
    productId: uuid("product_id")
      .notNull()
      .references(() => products.id, { onDelete: "cascade" }),
    locationId: uuid("location_id")
      .notNull()
      .references(() => inventoryLocations.id, { onDelete: "cascade" }),
    qty: integer("qty").notNull().default(0),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    pk: primaryKey({ columns: [t.productId, t.locationId] }),
    locationIdx: index("inventory_stock_location_id_idx").on(t.locationId),
  })
);

export type InventoryStock = typeof inventoryStock.$inferSelect;
export type NewInventoryStock = typeof inventoryStock.$inferInsert;
